<template>
  <div class="university-select">
    <div class="form-control-item form-control-item--dropdown">
      <validation-provider
        rules="required"
        v-slot="{ errors, invalid, touched }"
      >
        <label v-if="!item.hideLabel" :for="`${item.key}-${item.id}`">
          <span v-if="typeof item.label === 'function'">
            {{ item.label() }}
          </span>
          <span v-else> {{ item.label }}</span>
          <span v-if="item.required">*</span>
        </label>
        <div class="select-box">
          <select
            :id="`${item.key}`"
            :name="item.key"
            v-model="universityModel"
            :class="[
              { invalid: invalid },
              { touched: touched },
              { 'has-errors': errors.length > 0 },
            ]"
            :disabled="item.disabled"
          >
            <option v-if="!item.hideLabel" value="" selected disabled hidden>
              Please select...
            </option>
            <option v-else value="" selected disabled hidden>
              {{ item.label }}{{ item.required ? "*" : "" }}
            </option>
            <option
              v-for="option in item.options"
              :key="option.value"
              :value="option.value"
              :selected="universityModel === option.value"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
        <span class="validation-label">{{ errors[0] }}</span>
      </validation-provider>
    </div>
    <div
      class="form-control-item form-control-item--dropdown"
      v-if="studiedOutsideUk"
    >
      <validation-provider
        rules="required"
        v-slot="{ errors, invalid, touched }"
      >
        <label :for="`university-other-country`">
          <span>
            What country did you study in?
          </span>
          <span>*</span>
        </label>
        <div class="select-box">
          <select
            :id="`university-other-country`"
            name="universityOtherCountry"
            v-model="universityOtherCountryModel"
            :class="[
              { invalid: invalid },
              { touched: touched },
              { 'has-errors': errors.length > 0 },
            ]"
            :disabled="item.disabled"
          >
            <option value="" selected disabled hidden>
              Please select...
            </option>
            <option
              v-for="option in countryCodes"
              :key="option.value"
              :value="option.value"
              :selected="universityOtherCountryModel === option.value"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
        <span class="validation-label">{{ errors[0] }}</span>
      </validation-provider>
    </div>
    <div
      class="form-control-item form-control-item--text"
      v-if="studiedOutsideUk"
    >
      <validation-provider
        rules="required"
        v-slot="{ errors, invalid, touched }"
      >
        <label for="university-other-name">
          <span>What is the name of your university?</span><span>*</span>
        </label>
        <input
          v-model="universityOtherNameModel"
          :name="item.key"
          type="text"
          :class="[
            { invalid: invalid },
            { touched: touched },
            { 'has-errors': errors.length > 0 },
          ]"
        />
        <span class="validation-label">
          {{ errors[0] }}
          <span v-if="errors.length > 0 && item.hint">({{ item.hint }})</span>
        </span>
      </validation-provider>
    </div>
  </div>
</template>

<script>
import { registrationConfig } from "@/helpers/config";
import { useMemberDetails } from "@/helpers/member-details";
import { computed, ref, watch } from "@vue/composition-api";
import { ValidationProvider } from "vee-validate";

export default {
  props: ["item"],
  components: {
    ValidationProvider,
  },
  setup() {
    const {
      university,
      universityOtherCountry,
      universityOtherName,
    } = useMemberDetails();
    const universityModel = ref(university.value);
    const universityOtherCountryModel = ref(universityOtherCountry.value);
    const universityOtherNameModel = ref(universityOtherName.value);
    const countryCodes = Object.entries(registrationConfig.countries)
      .map(([value, text]) => ({
        value,
        text,
      }))
      .sort((a, b) => {
        const textA = a.text.toUpperCase();
        const textB = b.text.toUpperCase();
        if (textA < textB) {
          return -1;
        }
        if (textA > textB) {
          return 1;
        }

        return 0;
      });
    const { setUniversity } = useMemberDetails();
    const studiedOutsideUk = computed(() => university.value === "QOUK");

    watch(
      () => [
        universityModel.value,
        universityOtherCountryModel.value,
        universityOtherNameModel.value,
      ],
      ([university, otherCountry, otherName]) => {
        setUniversity(university, otherCountry, otherName);
      },
    );

    return {
      countryCodes,
      studiedOutsideUk,
      universityModel,
      universityOtherCountryModel,
      universityOtherNameModel,
    };
  },
};
</script>
